export default "__VITE_ASSET__C1_R4v6V__"